import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import '@fiverr/i18n/singleton';
import './style.scss';

const Countdown = ({ deadline, className }) => {
    const now = new Date(),
        deadlineArr = deadline.split(/[- : T]/).map((datePiece) => parseInt(datePiece, 10)),
        endDate = new Date(deadlineArr[0], deadlineArr[1]-1, deadlineArr[2], deadlineArr[3], deadlineArr[4], deadlineArr[5]).getTime(),
        t = endDate - now,
        expired = t <= 0,
        hoursLeft = Math.floor((t/(1000*60*60)) % 24),
        daysLeft = Math.floor(t/(1000*60*60*24)),
        countdownContent = expired ? i18n.t('countdown.expired'): [<i key={Math.random() * 100} className="fa fa-clock-o"/>, ` ${daysLeft}d ${hoursLeft}h`];

    return (<span className={classNames('countdown', className)}>{countdownContent}</span>);

};

Countdown.propTypes = {
    deadline: PropTypes.string
};

export default Countdown;



// WEBPACK FOOTER //
// ./src/shared/countdown/index.js